/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConflictResponse,
  ForbiddenResponse,
  NotFoundResponse,
  RoomAdmission,
  RoomState,
  ServiceUnavailableResponse,
  UnauthorizedResponse
} from '../model';

import { apiFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetRoomStateUrl = (occurrenceId: string,) => {




  return `/v1/occurrences/${occurrenceId}/room`
}

/**
 * midia, que sao Onda 1, e do provisionamento manual de LiveKit, TURN e
 * Egress, que a §15.3 mantem pendente.
 *
 * A sala tem admissao em duas fases: o aluno que chega antes fica em
 * `waiting_for_teacher` **sem chat**; o professor passa pela antessala e so
 * e admitido se a captura estiver pronta; o aluno so entra depois que a
 * captura confirma. Nao existe interacao professor-aluno fora de gravacao.
 * @summary Consulta o estado da sala de uma ocorrencia
 */
export const getRoomState = async (occurrenceId: string, options?: Parameters<typeof apiFetch>[1]): Promise<RoomState> => {

  return apiFetch<RoomState>(getGetRoomStateUrl(occurrenceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRoomStateQueryKey = (occurrenceId: string,) => {
    return [
    `/v1/occurrences/${occurrenceId}/room`
    ] as const;
    }


export const getGetRoomStateQueryOptions = <TData = Awaited<ReturnType<typeof getRoomState>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomState>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoomStateQueryKey(occurrenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoomState>>> = ({ signal }) => getRoomState(occurrenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: occurrenceId !== null && occurrenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoomState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRoomStateQueryResult = NonNullable<Awaited<ReturnType<typeof getRoomState>>>
export type GetRoomStateQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useGetRoomState<TData = Awaited<ReturnType<typeof getRoomState>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoomState>>,
          TError,
          Awaited<ReturnType<typeof getRoomState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoomState<TData = Awaited<ReturnType<typeof getRoomState>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoomState>>,
          TError,
          Awaited<ReturnType<typeof getRoomState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoomState<TData = Awaited<ReturnType<typeof getRoomState>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomState>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Consulta o estado da sala de uma ocorrencia
 */

export function useGetRoomState<TData = Awaited<ReturnType<typeof getRoomState>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoomState>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoomStateQueryOptions(occurrenceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRequestRoomAdmissionUrl = (occurrenceId: string,) => {




  return `/v1/occurrences/${occurrenceId}/room/admissions`
}

/**
 * midia, que sao Onda 1, e do provisionamento manual do SFU (§15.3).
 *
 * O backend nunca confia no nome exibido pelo cliente: o `displayName` que
 * aparece dentro da sala e o que o servidor emite, ja mascarado para quem
 * olha. Terceiro tentando entrar em dupla recebe 403 e gera registro de
 * `admission_denied`.
 *
 * Quando a captura nao esta pronta, a resposta e 409 e a aula nao ocorre.
 * @summary Pede admissao na sala e recebe o token efemero
 */
export const requestRoomAdmission = async (occurrenceId: string, options?: Parameters<typeof apiFetch>[1]): Promise<RoomAdmission> => {

  return apiFetch<RoomAdmission>(getRequestRoomAdmissionUrl(occurrenceId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRequestRoomAdmissionMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestRoomAdmission>>, TError,{occurrenceId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestRoomAdmission>>, TError,{occurrenceId: string}, TContext> => {

const mutationKey = ['requestRoomAdmission'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestRoomAdmission>>, {occurrenceId: string}> = (props) => {
          const {occurrenceId} = props ?? {};

          return  requestRoomAdmission(occurrenceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestRoomAdmissionMutationResult = NonNullable<Awaited<ReturnType<typeof requestRoomAdmission>>>

    export type RequestRoomAdmissionMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | ServiceUnavailableResponse

    /**
 * @summary Pede admissao na sala e recebe o token efemero
 */
export const useRequestRoomAdmission = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestRoomAdmission>>, TError,{occurrenceId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestRoomAdmission>>,
        TError,
        {occurrenceId: string},
        TContext
      > => {
      return useMutation(getRequestRoomAdmissionMutationOptions(options), queryClient);
    }
    export const getLeaveRoomUrl = (occurrenceId: string,) => {




  return `/v1/occurrences/${occurrenceId}/room/departures`
}

/**
 * Saida do professor inicia a tolerancia de reconexao de 90 s; passada
 * ela sem retorno, a captura encerra.
 * @summary Registra a saida da sala
 */
export const leaveRoom = async (occurrenceId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getLeaveRoomUrl(occurrenceId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLeaveRoomMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveRoom>>, TError,{occurrenceId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof leaveRoom>>, TError,{occurrenceId: string}, TContext> => {

const mutationKey = ['leaveRoom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof leaveRoom>>, {occurrenceId: string}> = (props) => {
          const {occurrenceId} = props ?? {};

          return  leaveRoom(occurrenceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LeaveRoomMutationResult = NonNullable<Awaited<ReturnType<typeof leaveRoom>>>

    export type LeaveRoomMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse

    /**
 * @summary Registra a saida da sala
 */
export const useLeaveRoom = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveRoom>>, TError,{occurrenceId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof leaveRoom>>,
        TError,
        {occurrenceId: string},
        TContext
      > => {
      return useMutation(getLeaveRoomMutationOptions(options), queryClient);
    }
    export const getAdmitSupportToRoomUrl = (occurrenceId: string,) => {




  return `/v1/occurrences/${occurrenceId}/room/support-admissions`
}

/**
 * **Exclusiva do papel de suporte tecnico.** Nao e uma operacao de Super
 * Admin com alcance maior: professor, aluno e Super Admin recebem 403
 * aqui, e a recusa nao tem excecao por hierarquia. Suporte e papel do
 * sistema, e nao um terceiro membro da dupla — a interface dos outros
 * papeis nao deve oferecer este caminho.
 *
 * O suporte entra numa sala que ja existe e **nao toca na captura**: nao a
 * inicia, nao a encerra, e nao muda a fase de admissao da dupla. A entrada
 * vira evento de sala e linha de auditoria, e a presenca aparece em
 * `RoomState.participants` com papel `support` — terceiro invisivel numa
 * aula gravada e o que a §15.2 proibe, e o registro e o que torna a
 * presenca conferivel depois.
 *
 * A resposta e vazia de proposito. Devolver `RoomState` entregaria de
 * brinde, a quem so precisava entrar, a lista de participantes e o estado
 * da captura da aula; quem precisar do estado chama `getRoomState`, cujo
 * escopo ja esta decidido.
 * @summary Registra a entrada do suporte tecnico numa sala
 */
export const admitSupportToRoom = async (occurrenceId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getAdmitSupportToRoomUrl(occurrenceId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdmitSupportToRoomMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof admitSupportToRoom>>, TError,{occurrenceId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof admitSupportToRoom>>, TError,{occurrenceId: string}, TContext> => {

const mutationKey = ['admitSupportToRoom'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof admitSupportToRoom>>, {occurrenceId: string}> = (props) => {
          const {occurrenceId} = props ?? {};

          return  admitSupportToRoom(occurrenceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdmitSupportToRoomMutationResult = NonNullable<Awaited<ReturnType<typeof admitSupportToRoom>>>

    export type AdmitSupportToRoomMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse

    /**
 * @summary Registra a entrada do suporte tecnico numa sala
 */
export const useAdmitSupportToRoom = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof admitSupportToRoom>>, TError,{occurrenceId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof admitSupportToRoom>>,
        TError,
        {occurrenceId: string},
        TContext
      > => {
      return useMutation(getAdmitSupportToRoomMutationOptions(options), queryClient);
    }
